<div class="flex justify-center">
  <a
    mat-button
    style="text-decoration: underline"
    color="primary"
    [href]="contractUrl"
    target="_blank"
    id="informativa-privacy-button"
    >LEGGI E SCARICA L'INFORMATIVA PRIVACY</a
  >
</div>

<div>
  <div class="my-4">
    @for (item of clauses; track $index) { @for (txt of item.text.split('-');
    track $index;) { @if (!item.text.includes(amlService.serialNumber!)) {
    <p>
      @if ($index !== 0) {
      <span> - </span>
      }
      {{ txt }}
    </p>
    } } }
  </div>

  <div class="button-container">
    <button mat-flat-button color="accent" (click)="confirm()">
      RICHIEDI IL CERTIFICATO
    </button>
  </div>
</div>
